import ExpertOpinion from './ExpertOpinion';
export default ExpertOpinion;
